import { render, staticRenderFns } from "./Ml18ClientePrincipal.vue?vue&type=template&id=2af9b448&"
import script from "./Ml18ClientePrincipal.vue?vue&type=script&lang=js&"
export * from "./Ml18ClientePrincipal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports